import React from "react";
import { styled } from "@mui/material/styles";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

const DatePickerContainer = styled('div')(({ theme }) => ({
  // marginBottom: "24px",
  // position: "relative",
  // padding: "10px",
}));

const LabelContainer = styled('div')(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  marginBottom: "8px",
  direction: "rtl",
}));

const StyledLabel = styled('label')(({ theme }) => ({
  fontSize: "16px",
  fontWeight: "500",
  color: "#053251",
  marginRight: "8px",
  letterSpacing: "0.3px",
}));

const RequiredIndicator = styled('span')(({ theme }) => ({
  color: "#ff6b6b",
  fontSize: "16px",
  fontWeight: "600",
  marginLeft: "4px",
}));

const DatePickerWrapper = styled('div')(({ theme }) => ({
  position: "relative",

  "& .rmdp-container": {
    width: "100%",
  },

  "& .rmdp-input": {
    width: "100%",
    padding: "18px 16px",
    fontSize: "15px",
    fontWeight: "400",
    border: "1px solid #233cb747",
    borderRadius: "10px",
    background: "linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 255, 254, 0.9) 100%)",
    color: "#053251",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    boxShadow: "0 2px 8px rgba(5, 50, 81, 0.05)",
    outline: "none",
    direction: "rtl",
    textAlign: "right",

    "&:hover": {
      borderColor: "rgba(124, 200, 144, 0.4)",
      boxShadow: "0 4px 12px rgba(124, 200, 144, 0.15)",
    },

    "&:focus": {
      borderColor: "#7cc890",
      boxShadow: "0 0 0 3px rgba(124, 200, 144, 0.1), 0 4px 16px rgba(124, 200, 144, 0.2)",
      background: "linear-gradient(135deg, #ffffff 0%, rgba(248, 255, 254, 0.95) 100%)",
    },

    "&::placeholder": {
      color: "rgba(5, 50, 81, 0.5)",
      fontWeight: "400",
    },
  },

  "& .rmdp-calendar": {
    background: "linear-gradient(145deg, #ffffff 0%, rgba(248, 255, 254, 0.9) 100%)",
    border: "1px solid rgba(124, 200, 144, 0.2)",
    borderRadius: "16px",
    boxShadow: "0 20px 40px rgba(5, 50, 81, 0.15), 0 8px 16px rgba(5, 50, 81, 0.1)",
    overflow: "hidden",
    fontFamily: "inherit",
  },

  "& .rmdp-header": {
    background: "linear-gradient(135deg, #053251 0%, #2a5a72 100%)",
    color: "white",
    borderRadius: "0",
    padding: "16px",

    "& .rmdp-arrow": {
      color: "white",
      "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.1)",
        borderRadius: "6px",
      },
    },

    "& span": {
      color: "white",
      fontWeight: "600",
    },
  },

  "& .rmdp-week-day": {
    color: "#053251",
    fontWeight: "500",
    fontSize: "13px",
    padding: "8px",
    background: "rgba(124, 200, 144, 0.05)",
  },

  "& .rmdp-day": {
    color: "#053251",
    fontSize: "14px",
    fontWeight: "400",
    transition: "all 0.2s ease",
    margin: "2px",
    borderRadius: "8px",
    
    "&:hover": {
      backgroundColor: "rgba(124, 200, 144, 0.1)",
      color: "#053251",
    },
    
    "&.rmdp-selected": {
      background: "linear-gradient(135deg, #7cc890 0%, #6bb57f 100%)",
      color: "white",
      fontWeight: "600",
      boxShadow: "0 2px 8px rgba(124, 200, 144, 0.3)",
    },
    
    "&.rmdp-today": {
      border: "2px solid #7cc890",
      backgroundColor: "rgba(124, 200, 144, 0.1)",
      fontWeight: "600",
    },
    
    "&.rmdp-disabled": {
      color: "rgba(5, 50, 81, 0.3)",
      backgroundColor: "rgba(5, 50, 81, 0.05)",
    },
  },
  
  "& .rmdp-month, & .rmdp-year": {
    color: "#053251",
    fontSize: "14px",
    
    "&:hover": {
      backgroundColor: "rgba(124, 200, 144, 0.1)",
    },
    
    "&.rmdp-selected": {
      background: "linear-gradient(135deg, #7cc890 0%, #6bb57f 100%)",
      color: "white",
    },
  },
}));

const PersianDatePicker = (props) => {
  return (
    <DatePickerContainer>
      <LabelContainer>
        <StyledLabel className="iran-sans">{props.name}</StyledLabel>
        <RequiredIndicator>{props.required ? "*" : ""}</RequiredIndicator>
      </LabelContainer>

      <DatePickerWrapper>
        <DatePicker
          style={{
            fontFamily: "MyPersianFont, sans-serif",
          }}
          value={props.value}
          onChange={(dateObject) => {
            const gregorianDate = dateObject.toDate();
            props.onChange(gregorianDate);
          }}
          placeholder={props.placeholder}
          calendar={persian}
          locale={persian_fa}
        />
      </DatePickerWrapper>
    </DatePickerContainer>
  );
};

export default PersianDatePicker;